import { useState } from "react";
import { X } from "lucide-react";

/** Compact tag/job-code editor used on Bill, Receipt and Income detail forms. */
const TagInput = ({ value = [], onChange, testid = "tag-input", placeholder = "Add tag (e.g. smith-12-hill)" }) => {
  const [draft, setDraft] = useState("");
  const tags = Array.isArray(value) ? value : [];

  const add = () => {
    const t = draft.trim().replace(/^#/, "").toLowerCase();
    if (!t) return;
    if (tags.includes(t)) {
      setDraft("");
      return;
    }
    onChange?.([...tags, t]);
    setDraft("");
  };

  const remove = (t) => onChange?.(tags.filter((x) => x !== t));

  return (
    <div data-testid={testid} className="flex flex-wrap items-center gap-2">
      {tags.map((t) => (
        <span
          key={t}
          data-testid={`${testid}-chip-${t}`}
          className="inline-flex items-center gap-1.5 border-2 border-black bg-white px-2 py-1 text-[11px] uppercase tracking-widest font-bold"
        >
          #{t}
          <button
            type="button"
            onClick={() => remove(t)}
            aria-label={`Remove tag ${t}`}
            className="text-neutral-500 hover:text-red-600"
          >
            <X className="h-3 w-3" />
          </button>
        </span>
      ))}
      <input
        data-testid={`${testid}-input`}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === ",") {
            e.preventDefault();
            add();
          } else if (e.key === "Backspace" && !draft && tags.length) {
            remove(tags[tags.length - 1]);
          }
        }}
        onBlur={add}
        placeholder={placeholder}
        className="swiss-input flex-1 min-w-[160px]"
      />
    </div>
  );
};

export default TagInput;
